<app-dashboard-subheader
  [(startDate)]="startDate"
  [(endDate)]="endDate"

  [(productCategoryIds)]="productCategoryIds"
  [(campaignIds)]="campaignIds"
  [(mediumIds)]="mediumIds"
  [(sourceIds)]="sourceIds"

  [productCategoryIdAllValue]="productCategoryIdAllValue"
  [campaignIdAllValue]="campaignIdAllValue"
  [mediumIdAllValue]="mediumIdAllValue"
  [sourceIdAllValue]="sourceIdAllValue"
/>

<app-dashboard
  [startDate]="startDate"
  [endDate]="endDate"
  [salesTeamId]="salesTeamId"
  [salesTeamMemberId]="salesTeamMemberId"

  [productCategoryIds]="productCategoryIds"
  [salesTeamIds]="salesTeamIds"
  [salesTeamMemberUserIds]="salesTeamMemberUserIds"
  [campaignIds]="campaignIds"
  [mediumIds]="mediumIds"
  [sourceIds]="sourceIds"

  [productCategoryIdAllValue]="productCategoryIdAllValue"
  [salesTeamIdAllValue]="salesTeamIdAllValue"
  [salesTeamMemberUserIdAllValue]="salesTeamMemberUserIdAllValue"
  [campaignIdAllValue]="campaignIdAllValue"
  [mediumIdAllValue]="mediumIdAllValue"
  [sourceIdAllValue]="sourceIdAllValue"
/>
